import { Card, CardContent } from '@/components/ui/card';

/**
 * 취소 및 환불 정책 페이지.
 * 전자결제(토스페이먼츠) 심사 요건상 환불정책을 독립 URL로 확인할 수 있어야 하며,
 * 내용은 실제 환불 플로우(결제/환불 내역 → 환불 신청 → 관리자 승인 → 원결제수단 취소)와 일치해야 한다.
 */
export default function RefundPolicyPage() {
  return (
    <div className="py-8 overflow-y-scroll">
      <div className="max-w-4xl mx-auto px-6">
        <Card className="bg-white shadow-sm">
          <CardContent className="p-8">
            {/* Header */}
            <div className="mb-8">
              <h1 className="text-2xl font-bold text-gray-900 mb-4">취소 및 환불 정책</h1>
              <p className="text-sm text-gray-600 leading-relaxed">
                {`퀘스토피아(www.questophia.com)를 운영하는 주식회사 퀘스토피아(이하 "회사")는
                「전자상거래 등에서의 소비자보호에 관한 법률」 등 관계 법령에 따라 아래와 같이 결제
                취소 및 환불 기준을 안내합니다.`}
              </p>
            </div>

            {/* 제1조 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 1조 판매 상품 및 서비스 제공기간
              </h2>
              <ul className="text-sm text-gray-600 space-y-2 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    회사가 판매하는 상품은 대학 강의와 연계된 온라인 학습 강좌 이용권(무형
                    서비스)입니다. 강좌별 이용료는 결제 단계의 결제창에서 확인할 수 있습니다.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    서비스 제공기간은 결제 완료 즉시 시작되며, 해당 강좌가 개설된 학기의
                    종료일까지입니다. (최대 6개월)
                  </span>
                </li>
              </ul>
            </section>

            {/* 제2조 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 2조 결제 수단
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                결제는 토스페이먼츠 전자결제 서비스를 통해 이루어지며, 신용·체크카드, 계좌이체 및
                간편결제를 이용할 수 있습니다.
              </p>
            </section>

            {/* 제3조 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 3조 청약철회 및 환불 기준
              </h2>
              <ol className="text-sm text-gray-600 space-y-3 ml-4 list-decimal list-inside">
                <li>
                  결제일로부터 10일 이내이고 강좌 이용(과제 열람·제출 등) 이력이 없는 경우, 전액
                  환불됩니다. (「전자상거래 등에서의 소비자보호에 관한 법률」 제17조)
                </li>
                <li>
                  서비스 이용 개시 후에는 총 이용기간 대비 경과 기간에 따라 아래 기준으로
                  환불됩니다.
                  <ul className="mt-2 ml-6 space-y-1 list-disc list-inside">
                    <li>총 이용기간의 3분의 1 경과 전: 이용료의 3분의 2에 해당하는 금액</li>
                    <li>총 이용기간의 2분의 1 경과 전: 이용료의 2분의 1에 해당하는 금액</li>
                    <li>총 이용기간의 2분의 1 경과 후: 환불 불가</li>
                  </ul>
                </li>
                <li>
                  회사의 귀책사유(중대한 서비스 장애 등)로 서비스를 이용할 수 없는 경우, 이용 불가
                  기간에 해당하는 금액 또는 전액을 환불합니다.
                </li>
              </ol>
            </section>

            {/* 제4조 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 4조 환불 신청 방법 및 처리
              </h2>
              <ul className="text-sm text-gray-600 space-y-2 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    로그인 후 [결제/환불 내역] 메뉴(www.questophia.com/payment)에서 환불을 신청할 수
                    있습니다. 환불 사유를 입력하면 접수됩니다.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    접수된 환불 신청은 영업일 기준 3~5일 이내에 검토·처리되며, 승인 시 원결제수단으로
                    결제가 취소됩니다. (카드 승인취소는 카드사 사정에 따라 3~7영업일이 소요될 수
                    있습니다.)
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>환불 관련 문의: admin@questophia.com</span>
                </li>
              </ul>
            </section>

            {/* 제5조 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 5조 기타
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                본 정책에 명시되지 않은 사항은 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관계
                법령 및 소비자분쟁해결기준에 따릅니다. 본 정책은 2026년 8월 17일부터 시행됩니다.
              </p>
            </section>

            {/* Footer */}
            <footer className="border-t border-gray-200 pt-6 mt-8">
              <div className="text-center text-sm text-gray-600 space-y-1">
                <p>(주)퀘스토피아 | 대표 : 송만철</p>
                <p>주소 : 서울시 강남구 영동대로 602, 6층 K267(삼성동, 삼성미켈란107)</p>
                <p>사업자등록번호 : 467-87-03443 | 문의 : admin@questophia.com</p>
              </div>
            </footer>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
